import { Box, Grid2, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { getSettings, saveSettings, ISettings } from './api';
import SingleSettingItem from './components/SingleSettingItem';
import { Button } from 'components/AppShell';
import { globalSnackbar } from 'components/GlobalSnackbar';

type UploadSettings = ISettings['upload_max_size'];

const SettingsPage = () => {
  const [uploadSettings, setUploadSettings] = useState<UploadSettings>();
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getSettings();
      setUploadSettings(data.upload_max_size);
    };
    fetchSettings();
  }, []);

  if (!uploadSettings || typeof uploadSettings !== 'object') {
    return <div>Нет данных</div>;
  }

  const handleChange = (key: keyof UploadSettings, value: number | null) => {
    setUploadSettings((prev) => (prev ? { ...prev, [key]: value } : prev));
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await saveSettings(uploadSettings);
      globalSnackbar({ message: 'Настройки сохранены', severity: 'success' });
    } catch (e) {
      globalSnackbar({
        message: e instanceof Error ? e.message : 'Не удалось сохранить настройки',
        severity: 'error',
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap="24px">
      <Box display="flex" justifyContent="space-between">
        <Typography fontSize={24} fontWeight={500}>
          Настройка размера файлов
        </Typography>
        <Button variant="primary" onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Сохранение…' : 'Сохранить'}
        </Button>
      </Box>
      <Grid2 container columns={4} spacing={2} width="100%">
        {(Object.entries(uploadSettings) as [keyof UploadSettings, number | null][]).map(
          ([key, value]) => (
            <Grid2 size={1} key={key}>
              <SingleSettingItem value={value} label={key} onChange={(v) => handleChange(key, v)} />
            </Grid2>
          )
        )}
      </Grid2>
    </Box>
  );
};

export default SettingsPage;
